// Shared time-scale math for Timeline + Gate views.
//
// We render the full operational day (02:00 → 00:00 next day = 22h) so
// dispatchers can pan across all banks. Width is driven by a per-minute
// pixel rate that the view scales via a zoom level.

export const WINDOW_START_MIN = 2 * 60;    // 02:00
export const WINDOW_END_MIN   = 24 * 60;   // 24:00 (= 00:00 next day)
export const WINDOW_SPAN_MIN  = WINDOW_END_MIN - WINDOW_START_MIN; // 1320

export const ZOOM_LEVELS = [
  { label: '1h',   pxPerMin: 1.5 },
  { label: '30m',  pxPerMin: 3   },
  { label: '15m',  pxPerMin: 6   },
  { label: '5m',   pxPerMin: 10  },
];
export const DEFAULT_ZOOM = 1;

export function widthForZoom(zoomIdx) {
  return WINDOW_SPAN_MIN * ZOOM_LEVELS[zoomIdx].pxPerMin;
}

export function pxFromMins(mins, pxPerMin) {
  return Math.max(0, (mins - WINDOW_START_MIN) * pxPerMin);
}

export function parseHHMMToMins(eta) {
  if (!eta) return null;
  const m = String(eta).match(/^(\d{1,2}):(\d{2})/);
  if (!m) return null;
  return parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
}

// Hour ticks across the window. Returns [{ minute, label }]
export function hourTicks() {
  const out = [];
  for (let m = WINDOW_START_MIN; m <= WINDOW_END_MIN; m += 60) {
    const h = Math.floor(m / 60) % 24;   // 24:00 → 0:00 (next day)
    out.push({ minute: m, label: `${h}:00` });
  }
  return out;
}

// Half-hour ticks (no labels).
export function halfHourTicks() {
  const out = [];
  for (let m = WINDOW_START_MIN + 30; m < WINDOW_END_MIN; m += 60) {
    out.push(m);
  }
  return out;
}
